import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  background-color: var(--color-white);
  position: relative;
`

const Title = styled.p`
  margin: 0;
  margin-right: auto;
  font-size: 14px;
`

const Form = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 0.5rem;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
  text-align: left;
`

const DisableScreen = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  bottom: 0;
  opacity: 0.3;
  background-color: var(--color-selago-grey);
`

const Textarea = styled.textarea<{ isError: boolean }>`
  position: relative;
  width: 100%;
  height: 88px;
  font-size: 14px;
  word-break: break-word;
  outline: none;
  border: none;
  //resize: none;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

const Error = styled.div`
  font-size: 12px;
  position: relative;
  color: var(--color-text-error);
  margin-top: -0.5rem;
  margin-right: auto;
`

const InputContainer = styled.div<{ isError: boolean }>`
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 10px;
  border-color: ${({ isError }) => (isError ? 'var(--color-text-error)' : 'lightgrey')};

  * {
    padding: 1rem;
    border-radius: inherit;
  }

  & input {
    font-size: 14px;
    font-weight: 400;
    color: rgb(68, 68, 68);
    border-color: rgb(229, 229, 229);
    border-bottom: none;
    border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
  }
`

const TitleInput = styled.input`
  font-weight: 600;
  font-size: 14px;
  color: rgb(68, 68, 68);
  border: none;
  outline: none;
  width: 100%;
`

const selectCustomStyles = {
  control: (provided, state) => {
    const error = !state.hasValue && !state.isFocused && state.selectProps.touched

    return {
      ...provided,
      border: error ? '1px solid red' : '1px solid var(--color-mischka-grey)',
      outline: 'none',
      boxShadow: 'none',
      borderRadius: 10,
      // padding: '2px 6px',
      padding: '0.5rem',
      '&:hover': {
        border: error ? '1px solid red' : '1px solid rgba(53, 64, 82, 0.5)',
        boxShadow: 'none',
      },
    }
  },
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  singleValue: provided => ({
    ...provided,
    color: 'var(--color-oxford-blue)',
    fontSize: 14,
  }),
  option: (provided, state) => {
    return {
      ...provided,
      fontSize: 14,
      cursor: 'pointer',
      backgroundColor: state.isFocused ? 'var(--color-hover-overlay-primary)' : 'var(--color-white)',
      color: 'var(--color-text-primary)',
      '&:hover': {
        fontSize: 14,
        backgroundColor: state.isFocused ? 'var(--color-hover-overlay-primary)' : 'var(--color-white)',
        color: 'var(--color-text-primary)',
      },
    }
  },
  menu: provided => ({
    ...provided,
    padding: 0,
    overflow: 'hidden',
  }),
  placeholder: provided => ({
    ...provided,
    color: 'rgba(53, 64, 82, 0.5)',
    fontSize: 14,
    width: 'max-content',
  }),
}

const SelectorContainer = styled.div`
  width: 100%;

  & > div:first-child {
    margin-bottom: 8px;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 0.5rem;
  position: relative;
  justify-content: flex-end;
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const RowCell = styled.div<{ isError: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

const SwitchContainer = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  user-select: none;
  margin-right: auto;
`

const SwitchTrack = styled.div<{ checked: boolean; disabled: boolean }>`
  position: relative;
  width: 48px;
  height: 24px;
  background-color: ${({ checked, disabled }) => {
    if (disabled) return '#e0e0e0'
    return checked ? '#4CAF50' : '#ccc'
  }};
  border-radius: 12px;
  transition: background-color 0.3s ease;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background-color: ${({ checked, disabled }) => {
      if (disabled) return '#e0e0e0'
      return checked ? '#45a049' : '#b3b3b3'
    }};
  }
`

const SwitchThumb = styled.div<{ checked: boolean }>`
  position: absolute;
  top: 2px;
  left: ${({ checked }) => (checked ? '26px' : '2px')};
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`

const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
`

const SwitchLabel = styled.span<{ checked: boolean }>`
  font-size: 14px;
  color: ${({ checked }) => (checked ? '#4CAF50' : '#666')};
  font-weight: 500;
  transition: color 0.3s ease;
`

export {
  Container,
  Title,
  Form,
  DisableScreen,
  Textarea,
  Error,
  InputContainer,
  TitleInput,
  Footer,
  SelectorContainer,
  selectCustomStyles,
  SwitchContainer,
  SwitchTrack,
  SwitchThumb,
  HiddenCheckbox,
  SwitchLabel,
}
